//action types
export const GET_ANNOUNCEMENTS = 'GET_ANNOUNCEMENTS';

//get 
export function getAnnouncements(data, callback) {
  return {
    type: GET_ANNOUNCEMENTS,
    payload : {data, callback},
  };
}